module.exports = __webpack_public_path__ + "static/media/solar-panel.73b7787f.svg";